import Skeleton from "react-loading-skeleton";
import "./skeleton.scss";

const TableSkeleton = ({ rows = 5, columns = 3 }) => {
    return Array.from({ length: rows }).map((_, rowIndex) => (
        <table>
            <thead>
                <tr key={rowIndex}>
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <th key={colIndex}>
                            <Skeleton height={20} />
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <tr key={rowIndex}>
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <td key={colIndex}>
                            <Skeleton height={20} />
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    ));
};

export default TableSkeleton